import { css } from 'lit';

export default css`
    :host {
        --transition-fast: 0.2s;
        --transition-normal: 0.3s;
        --chevron-size: 0.45em;
        --chevron-weight: 0.15em;
    }

    .item {
        display: flex;
        align-items: center;
        padding: var(--metrics-spacing-m) var(--metrics-spacing-l);
        gap: var(--metrics-spacing-m);
        cursor: pointer;
        transition: background-color var(--transition-fast);
        border-left: var(--metrics-spacing-xs) solid transparent;
    }

    .item:hover {
        background-color: var(--color-surface-hover);
    }

    .item.selected {
        background-color: var(--color-surface-selected, #dae9f4);
    }

    .item.selected:hover {
        background-color: var(--color-surface-selected, #c2dbed);
    }

    /* Alarm status border colors */
    .item.status-good {
        border-left-color: var(--color-classes-outline-good);
    }

    .item.status-warning {
        border-left-color: var(--color-classes-outline-warning);
    }

    .item.status-alarm {
        border-left-color: var(--color-classes-outline-alarm);
    }

    /* Status icon */
    .status-icon {
        width: var(--grid-5);
        height: var(--grid-5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: var(--color-icon-primary);
        font-size: var(--font-size-icon-m);
    }

    .status-icon.icon-good {
        border: 1px solid var(--color-classes-outline-good);
        background-color: var(--color-classes-fill-good);
    }

    .status-icon.icon-warning {
        border: 1px solid var(--color-classes-outline-warning);
        background-color: var(--color-classes-fill-warning);
    }

    .status-icon.icon-alarm {
        border: 1px solid var(--color-classes-outline-alarm);
        background-color: var(--color-classes-fill-alarm);
    }

    .status-icon.icon-undefined {
        border: 1px solid var(--color-classes-outline-nodata);
        background-color: var(--color-classes-fill-nodata);
    }

    /* Body */
    .body {
        flex: 1;
        min-width: 0;
    }

    .name {
        font-size: var(--font-size-body-m);
        color: var(--color-text-primary);
        word-wrap: break-word;
    }

    .name .bell-icon {
        margin-left: var(--metrics-spacing-xs);
        color: var(--color-text-highlight-1);
    }

    .meta {
        display: flex;
        align-items: center;
        gap: var(--metrics-spacing-s);
        margin-top: var(--metrics-spacing-xs);
    }

    .meta-value {
        color: var(--color-text-highlight-1);
        font-size: var(--font-size-body-m);
    }

    .meta-date {
        color: var(--color-text-secondary);
        font-size: var(--font-size-body-m);
    }

    /* Chevron / expand toggle */
    .expand-toggle {
        padding: var(--metrics-spacing-s) var(--metrics-spacing-m);
        cursor: pointer;
    }

    .chevron::before {
        border-style: solid;
        border-width: var(--chevron-weight) var(--chevron-weight) 0 0;
        content: '';
        display: inline-block;
        height: var(--chevron-size);
        width: var(--chevron-size);
        position: relative;
        transform: rotate(135deg);
        transition: transform var(--transition-fast);
        border-color: var(--color-text-primary);
    }

    .chevron.expanded::before {
        transform: rotate(-45deg);
        top: var(--chevron-weight);
    }

    /* Detail panel (alarm bar + push toggle) */
    .detail-panel {
        overflow: hidden;
        max-height: 0;
        padding: 0 var(--metrics-spacing-l);
        transition:
            max-height var(--transition-normal) ease,
            padding var(--transition-normal) ease;
        background-color: var(--color-surface-primary);
    }

    .detail-panel.open {
        max-height: var(--grid-16);
        padding: var(--metrics-spacing-m) var(--metrics-spacing-l);
    }

    .detail-panel ki-ds-pwa-alarm-bar {
        width: 100%;
    }

    .detail-title {
        color: var(--color-text-primary);
        margin-bottom: var(--metrics-spacing-s);
        font-size: var(--font-size-body-s);
    }

    @media (max-width: 768px) {
        .item:not(.selected):hover {
            background-color: var(--color-surface-primary);
        }
        .name {
            font-size: var(--font-size-body-m);
        }
    }
`;
